export const state = () => ({
})

export const getters = {
}

export const mutations = {
}

export const actions = {
  async getElements({ commit }, {pdfTemplate}) {
    return await this.$api.customPDF.getElements(pdfTemplate)
  },

  async generatePDF({ commit }, {code, data}) {
    return await this.$api.customPDF.generatePDF(code, data);
  },
}
